import angular from 'angular';
import BackgroundCheck from 'background-check/background-check';

export default angular.module('hj.backgroundImage', [])
  .directive('hjBackgroundImage', function () {
    return {
      restrict: 'A',
      scope: {
        images: '=',
        maxDuration: '=',
        threshold: '=',
      },
      controllerAs: 'vm',
      bindToController: true,
      controller: ['$scope', '$element', '$timeout',
        function ($scope, $element, $timeout) {
          'ngInject';

          var vm = this;

          var defaults = {
            targets: $element[0],
            maxDuration: 500,
            threshold: 50,
          };

          var options = angular.extend(defaults, vm);

          $timeout(function () {
            BackgroundCheck.init(options);

            $timeout(function () {
              BackgroundCheck.refresh();
            }, 100);
          });

          // $scope.$on('$destroy', () => {
          //   BackgroundCheck.destroy();
          // });

        }],
    };
  });
